import { render, staticRenderFns } from "./RosterTemplate.vue?vue&type=template&id=08df31f6&"
import script from "@/views/RosterTemplates/RosterTemplate.ts?vue&type=script&lang=ts&"
export * from "@/views/RosterTemplates/RosterTemplate.ts?vue&type=script&lang=ts&"
import style0 from "@/views/RosterTemplates/roster-template.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports